module.exports = __webpack_public_path__ + "media/images/bg-bitcoin1-02d8b68d4d0721f6e3f02247e980f183.jpg";